<div class="container-fluid">
  <div class="d-flex h-100">
    <!-- Sidebar -->
    <div
      class="sidebar h-100"
      [ngClass]="{ 'mobile-open': isMobileMenuOpen, 'd-none d-lg-block': !isMobileMenuOpen }"
      #sidebar
    >
      <div class="sidebar-wrapper">
        <div class="bar-head">
          <img src="assets/images/onboarding/newbrijjlogo.svg" style="height: 5rem; width: 6rem" />
        </div>
        <div class="bar-options">
          <ul class="list-unstyled mb-0">
            <!-- Dashboard -->
            <li class="tool-wrap" (click)="toggleSubMenus(0)">
              <a
                [routerLink]="companyId == -1 ? '/admin-portal/admin-dashboard' : '/home'"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <img src="../../../../assets/images/duo-icons_dashboard.svg" />
                <span class="module-name">Dashboard</span>
              </a>
              <span class="tool-tip">Dashboard</span>
            </li>

            <!-- Company Management -->
            <ng-container *ngxPermissionsOnly="['Company:View']">
              <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/admin-portal/company-management/company-listing'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img src="../../../../assets/images/duo-icons_building.svg" />
                  <span class="module-name">Company Management</span>
                </a>
                <span class="tool-tip">Company Management</span>
              </li>
            </ng-container>

            <!-- Subscription Management -->
            <!-- <ng-template [ngxPermissionsOnly]="['SubscriptionPlan:View']">
              <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
                <a
                  href="javascript:void(0)"
                  [class.active]="isMenuActive(allMenus[3])"
                >
                  <img src="../../../../assets/images/duo-icons_file.svg" />
                  <span class="module-name">Data Management</span>
                </a>
                <span class="tool-tip">Subscription Management</span>
              </li>
            </ng-template> -->

            <!-- User Management -->
            <ng-container *ngxPermissionsOnly="['Role:View', 'User:View']">
              <li class="tool-wrap" *ngIf="companyId !== -1" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/company-portal/user-management/user'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img src="../../../../assets/images/duo-icons_user.svg" />
                  <span class="module-name">User Management</span>
                </a>
                <span class="tool-tip">User Management</span>
              </li>
            </ng-container>

            <ng-container *ngxPermissionsOnly="['Role:View', 'User:View']">
              <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/admin-portal/user-management/users-listing'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img src="../../../../assets/images/duo-icons_user.svg" />
                  <span class="module-name">User Management</span>
                </a>
                <span class="tool-tip">User Management</span>
              </li>
            </ng-container>

            <!-- Product Management -->
            <li
              class="tool-wrap"
              *ngIf="companyId != -1 && allMenus[0].submenus.submenuArray.length > 0"
              (click)="toggleSubMenus(1)"
            >
              <a href="javascript:void(0)" [class.active]="isMenuActive(allMenus[0])">
                <img
                  src="../../../../assets/images/ic_productManagment.svg"
                  style="height: 1.6rem; width: 1.6rem"
                />
                <span class="module-name">Product Management</span>
              </a>
              <span class="tool-tip">Product Management</span>

              <!-- Mobile Accordion Submenu -->
              <div
                class="mobile-submenu d-lg-none"
                [class.open]="isExpandSubMenu && submenusParentId === 1"
              >
                <ul class="submenuList">
                  <li
                    *ngFor="let mn of allMenus[0]?.submenus?.submenuArray"
                    [routerLink]="mn.route"
                    routerLinkActive="subActive"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="$event.stopPropagation()"
                  >
                    {{ mn.menu }}
                  </li>
                </ul>
              </div>
            </li>

            <!-- Data Management -->
            <ng-container
              *ngxPermissionsOnly="[
                'Brand:View',
                'ProductAttribute:View',
                'ProductCategory:View',
                'ProductDepartment:View',
                'StoreGroup:View',
                'StoreType:View',
              ]"
            >
              <li
                class="tool-wrap"
                *ngIf="companyId == -1 && allMenus[3].submenus.submenuArray.length > 0"
                (click)="toggleSubMenus(4)"
              >
                <a href="javascript:void(0)" [class.active]="isMenuActive(allMenus[3])">
                  <img
                    src="../../../../assets/images/ic_productManagment.svg"
                    style="height: 1.6rem; width: 1.6rem"
                  />
                  <span class="module-name">Data Management</span>
                </a>
                <span class="tool-tip">Data Management</span>

                <!-- Mobile Accordion Submenu -->
                <div
                  class="mobile-submenu d-lg-none"
                  [class.open]="isExpandSubMenu && submenusParentId === 4"
                >
                  <ul class="submenuList">
                    <li
                      *ngFor="let mn of allMenus[3]?.submenus?.submenuArray"
                      [routerLink]="mn.route"
                      routerLinkActive="subActive"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="$event.stopPropagation()"
                    >
                      {{ mn.menu }}
                    </li>
                  </ul>
                </div>
              </li>
            </ng-container>

            <!-- Store Management -->
            <li
              class="tool-wrap"
              *ngIf="companyId != -1 && allMenus[2].submenus.submenuArray.length > 0"
              (click)="toggleSubMenus(3)"
            >
              <a href="javascript:void(0)" [class.active]="isMenuActive(allMenus[2])">
                <img
                  src="../../../../assets/images/company-management/store_management.svg"
                  style="height: 1.6rem; width: 1.6rem"
                />
                <span class="module-name">Store Management</span>
              </a>
              <span class="tool-tip">Store Management</span>

              <!-- Mobile Accordion Submenu -->
              <div
                class="mobile-submenu d-lg-none"
                [class.open]="isExpandSubMenu && submenusParentId === 3"
              >
                <ul class="submenuList">
                  <li
                    *ngFor="let mn of allMenus[2]?.submenus?.submenuArray"
                    [routerLink]="mn.route"
                    routerLinkActive="subActive"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="$event.stopPropagation()"
                  >
                    {{ mn.menu }}
                  </li>
                </ul>
              </div>
            </li>

            <!-- Warehouse Management -->
            <li
              hidden
              class="tool-wrap"
              *ngIf="companyId != -1 && allMenus[1].submenus.submenuArray.length > 0"
              (click)="toggleSubMenus(2)"
            >
              <a href="javascript:void(0)" [class.active]="isMenuActive(allMenus[1])">
                <img
                  src="../../../../assets/images/ic_warehouse.svg"
                  style="height: 1.6rem; width: 1.6rem"
                />
                <span class="module-name">Warehouse Management</span>
              </a>
              <span class="tool-tip">Warehouse Management</span>

              <!-- Mobile Accordion Submenu -->
              <div
                class="mobile-submenu d-lg-none"
                [class.open]="isExpandSubMenu && submenusParentId === 2"
              >
                <ul class="submenuList">
                  <li
                    *ngFor="let mn of allMenus[1]?.submenus?.submenuArray"
                    [routerLink]="mn.route"
                    routerLinkActive="subActive"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="$event.stopPropagation()"
                  >
                    {{ mn.menu }}
                  </li>
                </ul>
              </div>
            </li>

            <!-- Billing System -->
            <ng-container *ngxPermissionsOnly="['SubscriptionPlan:View']">
              <li
                class="tool-wrap"
                *ngIf="companyId == -1 && allMenus[4].submenus.submenuArray.length > 0"
                (click)="toggleSubMenus(5)"
              >
                <a href="javascript:void(0)" [class.active]="isMenuActive(allMenus[4])">
                  <app-icon name="dollar" width="24" height="24" style="color: #000000"></app-icon>
                  <span class="module-name">Billing System</span>
                </a>
                <span class="tool-tip">Billing System</span>

                <!-- Mobile Accordion Submenu -->
                <div
                  class="mobile-submenu d-lg-none"
                  [class.open]="isExpandSubMenu && submenusParentId === 5"
                >
                  <ul class="submenuList">
                    <li
                      *ngFor="let mn of allMenus[4]?.submenus?.submenuArray"
                      [routerLink]="mn.route"
                      routerLinkActive="subActive"
                      [routerLinkActiveOptions]="{ exact: true }"
                      (click)="$event.stopPropagation()"
                    >
                      {{ mn.menu }}
                    </li>
                  </ul>
                </div>
              </li>
            </ng-container>

            <!-- Subscription Change Requests -->
            <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
              <a
                [routerLink]="'/admin-portal/subscription-change-requests'"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <app-icon name="refresh" width="24" height="24" style="color: #000000"></app-icon>
                <span class="module-name">Subscription Change Requests</span>
              </a>
              <span class="tool-tip">Subscription Change Requests</span>
            </li>

            <!-- Callback Requests -->
            <ng-container *ngxPermissionsOnly="['CallbackRequest:View']">
              <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/admin-portal/callback-requests'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img
                    style="width: 24px; height: 24px"
                    src="../../../../assets/images/recall.png"
                  />
                  <span class="module-name">Callback Requests</span>
                </a>
                <span class="tool-tip">Callback Requests</span>
              </li>
            </ng-container>

            <!-- Upload Latest Builds -->
            <ng-template [ngxPermissionsOnly]="['Upload:FlutterApp']">
              <li class="tool-wrap" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/admin-portal/upload-latest-build'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img
                    style="width: 24px; height: 24px"
                    src="../../../../assets/images/upload-sign.svg"
                  />
                  <span class="module-name">Upload Latest Builds</span>
              </a>
                <span class="tool-tip">Upload Latest Builds</span>
              </li>
            </ng-template>

            <!-- Data Migration -->
            <ng-template [ngxPermissionsOnly]="['DataMigration:View']">
              <li class="tool-wrap" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/data-migration/dashboard'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img
                    style="width: 24px; height: 24px"
                    src="../../../../assets/images/dm_tool_menu_icon_bw.svg"
                  />
                </a>
                <span class="tool-tip">Data Migration</span>
              </li>
            </ng-template>
            <!-- Inventory Management (external) -->
            <li
              class="tool-wrap"
              *ngIf="companyId != -1 && canShowImsMenu === false"
              (click)="toggleSubMenus(0); redirectToModule(Apps.Inventory)"
            >
              <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <i class="fa-solid fa-warehouse" style="color: #080b12"></i>
                <span class="module-name">Inventory Management</span>
              </a>
              <span class="tool-tip">Inventory Management</span>
            </li>

            <!-- App Downloads -->
            <li class="tool-wrap" *ngIf="companyId !== -1 && canShowAppDownloadsMenu" (click)="toggleSubMenus(0)">
              <a
                [routerLink]="'/company-portal/app-downloads'"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="fa-solid fs-5 fa-download fa-fw" style="color: #080b12"></i>
                <span class="module-name">App Downloads</span>
              </a>
              <span class="tool-tip">App Downloads</span>
            </li>

            <!-- Analytics -->
            <li class="tool-wrap" *ngIf="companyId !== -1">
              <app-analytics-menu
                [appId]="companyAppId"
                [baseRoute]="'/company-portal'"
                [companyId]="companyId"
              ></app-analytics-menu>
            </li>
          </ul>

          <!-- Settings -->
          <ul class="list-unstyled mb-0" *ngIf="companyId > 0 || companyId == -1">
            <li class="tool-wrap" (click)="toggleSubMenus(0)">
              <a
                [routerLink]="
                  companyId == -1
                    ? '/admin-portal/settings/datadog-settings'
                    : '/company-portal/settings/company-settings'
                "
                [ngClass]="{ active: settingRoutes.includes(currentRoute) }"
              >
                <img src="../../../../assets/images/duo-icons_settings.svg" />
                <span class="module-name">Settings</span>
              </a>
              <span class="tool-tip">Settings</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="w-100">
      <div class="header-container details-header sticky-top d-lg-none">
        <button class="back-btn" data-testid="mobile-menu-btn" (click)="toggleMobileMenu()">
          <img src="assets/images/navigation/menu-icon.svg" class="Menuicon" alt="Menu icon" />
        </button>
        <span class="header-title" data-testid="mobile-dashboard-title">Dashboard</span>
        <div class="spacer"></div>
      </div>
      <div class="nav-bar d-none d-lg-block">
        <app-navmenu></app-navmenu>
      </div>
      <div class="brij-content d-flex">
        <!-- Submenus -->
        <div
          #submenuSidebar
          [ngClass]="{ 'submenu-open': isExpandSubMenu, 'submenu-closed': !isExpandSubMenu }"
          class="submenus"
        >
          <p class="submenuhead">{{ submenus.menu }}</p>
          <div class="divider"></div>
          <ul class="submenuList">
            <ng-container *ngFor="let mn of submenus.submenuArray; trackBy: trackById">
              <ng-container *ngxPermissionsOnly="[mn.permission]">
                <li
                  [routerLink]="mn.route"
                  routerLinkActive="subActive"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [hidden]="mn.menu === 'Label Formats' && canShowLabelFormat === false"
                >
                  {{ mn.menu }}
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </div>

        <div
          [ngStyle]="{ 'flex-basis': !isExpandSubMenu ? '100%' : '85%' }"
          style="height: 100%; overflow: hidden"
        >
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Backdrop/Overlay -->
  <div class="mobile-overlay" *ngIf="isMobileMenuOpen" (click)="isMobileMenuOpen = false"></div>
</div>
